<div class="bina-catalog-search" [ngClass]="{ 'full-width': isFullWidth }">
  <form class="bina-catalog-search__form" autocomplete="off" (submit)="onSubmit()">
    <div class="form-group flex-grow-1">
      <app-control-wrapper classGroup="m-0" [control]="searchForm.get('searchParameter')" [isShowHelper]="false">
        <input
          control-wrapper
          type="text"
          [formControl]="searchForm.get('searchParameter')"
          class="form-control"
          id="searchParameter"
          name="searchParameter"
          placeholder="{{ 'BUTTON.SEARCH' | translate }}"
          [mask]="'F{100}'"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
          [dropSpecialCharacters]="false"
          [patterns]="CUSTOM_MASK"
        />
      </app-control-wrapper>
      <div class="bina-catalog-search__input-icon" (click)="onSubmit()">
        <img src="/assets/icons/icon_search.svg" alt="magnifying glass" />
      </div>
    </div>
    <div class="bina-catalog-search__clear-button" (click)="clearFilters()" *ngIf="!!isShowClearButton">
      <img
        class="bina-catalog-search__clear-button__icon"
        nz-tooltip
        nzTooltipPlacement="top"
        [nzTooltipTitle]="'BUTTON.CLEAR' | translate"
        src="assets/icons/icon_trash.svg"
      />
    </div>
  </form>
</div>
